// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-skeleton-loader[data-v-7b2f54b5]  .v-skeleton-loader__heading{width:100%}.v-skeleton-loader[data-v-7b2f54b5]  .v-skeleton-loader__image{height:100%;width:100%}.media-carousel-loader .v-skeleton-loader[data-v-7b2f54b5]{height:300px;width:400px}.person-grid-loader .v-skeleton-loader[data-v-7b2f54b5]{height:140px;width:140px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
